import { FC } from 'react'

/**
 * * Icon Component for: data-03
 */
type GoogleIconProps = {
  size?: number
  color?: string
}
export const GoogleIcon: FC<GoogleIconProps> = ({ size = '14', color = 'currentColor', ...rest }) => {
  const viewBox = `0 0 ${size} ${size}`
  return (
    <svg width={size} height={size} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.206 8.56771H19.8405C19.9468 9.14931 20 9.70486 20 10.2344C20 12.1181 19.5969 13.7999 18.7907 15.2799C17.9845 16.76 16.835 17.9167 15.3422 18.75C13.8494 19.5833 12.1373 20 10.206 20C8.81506 20 7.49059 19.7374 6.23256 19.2122C4.97453 18.6871 3.88926 17.9774 2.97674 17.0833C2.06423 16.1892 1.33998 15.1259 0.803987 13.8932C0.267996 12.6606 0 11.3628 0 10C0 8.63715 0.267996 7.33941 0.803987 6.10677C1.33998 4.87413 2.06423 3.81076 2.97674 2.91667C3.88926 2.02257 4.97453 1.31293 6.23256 0.78776C7.49059 0.262587 8.81506 0 10.206 0C12.8638 0 15.1451 0.872396 17.0498 2.61719L14.2724 5.23437C13.1827 4.20139 11.8272 3.6849 10.206 3.6849C9.06312 3.6849 8.00664 3.96701 7.03654 4.53125C6.06645 5.09549 5.2979 5.86154 4.7309 6.82943C4.1639 7.79731 3.8804 8.85417 3.8804 10C3.8804 11.1458 4.1639 12.2027 4.7309 13.1706C5.2979 14.1385 6.06645 14.9045 7.03654 15.4687C8.00664 16.033 9.06312 16.3151 10.206 16.3151C10.9767 16.3151 11.6855 16.2109 12.3322 16.0026C12.979 15.7943 13.5105 15.5339 13.9269 15.2214C14.3433 14.9089 14.7065 14.553 15.0166 14.1536C15.3267 13.7543 15.5548 13.3767 15.701 13.0208C15.8472 12.6649 15.9468 12.3264 16 12.0052H10.206V8.56771Z"
        fill="#4F4D55"
      />
    </svg>
  )
}
